<template>
  <div class="cb" v-if="kbxmlc">
    <!-- 多次报价中 -->
    <template v-if='dcbjjssj&& role == "Z"'>
      <div class="bjBtn">
        <p class='numP'>当前第<span class='bjNum'>{{dcbjcs}}</span>轮报价<template v-if='dqbjsfzzbj'> (最终报价)</template>  </p>
        <div class="clear">
          <div class='clockBox'>
            <p class='time'>报价剩余时间</p>
            <myClock
             class='lf'
              :shenyu="dcbjjssj"
              :key="dcbjjssj"
              cId="c1"
            ></myClock>
          </div>
        </div>
        <!-- <p class='total'>共{{tbdwsl}}家，已报价{{tbdwyxgsl}}家，待报价{{tbdwwxgsl}}家。</p> -->
        <p class='total'>有效投标家数{{tbdwsl}}家，已报价{{tbdwyxgsl}}家。</p>
      </div>
      <el-button
        type="primary lcNext"
        @click="stopBj"
        >结束报价</el-button>
    </template>
    <template v-else>
      <div :class="['box', kbxmlc.zt == '2' || role != 'Z' ? 'noBtn' : '']">
        <div class="clear">
          <p class="cont-title lf">唱标</p>
          <div class="rt">
            <template v-if="role == 'Z'">
              <el-button
                type="primary"
                @click="openBj"
                :disabled='!dcbjzt||evalEnd'
                >开启多轮报价</el-button
              >
              <el-button
                type="primary"
                @click="setCs"
                v-if="sfycs"
                >参数设置</el-button
              >
            </template>
            <template v-else>
              <el-button
                type="primary"
                @click="createMoreReportForm"
                v-if='pbsfyjs'
                >
                多轮报价报表
              </el-button>
            </template>
          </div>
        </div>
        <p
          class='red'
          style="line-height:26px;"
          v-if="sfycs"
          >
          <span v-if="newTips">
            {{ newTips }}
          </span>
          <span v-else>
            {{
              role == "Z" ? "请按招标文件要求设置参数" : "请等待设置参数"
            }}
          </span>
        </p>
        <p class='numP' style="margin-top:200px" v-if='role=="Z"'>
          <template v-if='!dcbjcs'>共<span class='bjNum'>{{jmSuccessNum}}</span>家单位解密成功</template>
          <template v-else>第{{['','一','二','三','四','五','六'][dcbjcs]}}轮报价结束</template>
        </p>
        <p v-else class='numP' style="margin-top:200px">
          共<span class='bjNum'>{{jmSuccessNum}}</span>家单位解密成功
        </p>
      </div>
      <el-button
        type="primary lcNext"
        @click="nextBtn"
        v-if="kbxmlc.zt != '2' && role == 'Z'"
        :disabled="waitLoading"
        >下一步</el-button>
    </template>
    <!-- 设置报价时间 -->
    <el-dialog
      title="开启多轮报价"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="dialogBox">
        <p class='bjNumP'>当前第<span class='bjNum'>{{dcbjcs+1}}</span>轮报价</p>
        <el-form ref="timeForm" :model="timeForm" label-width="160px">
          <el-form-item label="报价倒计时设置" prop="dcbjsj" :rules="[{required:true,message:'必填项',trigger:'blur'}]">
            <el-input v-model.number="timeForm.dcbjsj" type="number" style="width:180px"></el-input> 分钟
          </el-form-item>
          <el-form-item label="是否最终报价" prop="sfzzbj" :rules="[{required:true,message:'必选项',trigger:'change'}]">
            <el-select v-model="timeForm.sfzzbj" placeholder="请选择" style="width:180px">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="saveBjTime('timeForm')" :disabled="waitLoading"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!-- 设置参数 -->
    <el-dialog
      title="设置参数"
      :visible.sync="dialogFormVisible"
      width="580px"
      :close-on-click-modal="false"
    >
      <el-form :model="form" ref="form" label-width="285px" :disabled="!canSet">
        <el-form-item
          :label="item.csmc"
          v-for="(item, index) in formItem"
          :key="index"
          :prop="item.csdm"
          :rules="
            /^[a-z]$/g.test(item.csdm)
              ? [{ validator: validateFieldMethods, trigger: 'blur' }]
              : [{ required: true, message: '必填项', trigger: 'blur' }]
          "
        >
          <!-- <el-input oninput="value=value.replace(/[^\d.]/g,'').replace(/^\./g, '')"  v-model="form[item.csdm]" style='width:300px'></el-input> {{item.cshz}} -->
          <template v-if="objectType == 1">
            <el-select
            v-if="item.yzgz == 'select'"
              v-model="form[item.csdm]"
              style="width: 150px"
            >
            <el-option 
            v-for="a in item.urldz.split(',')"
            :key="a" 
            :label="a" 
            :value="a"></el-option>
            </el-select>
            <el-input
              v-else
              oninput="value=value.replace(/[^\d\.\-0]/g,'').replace(/^\./g, '')"
              v-model="form[item.csdm]"
              style="width: 150px"
            ></el-input>
          </template>
          
          <template v-else>
            <el-select
            v-if="item.yzgz == 'select'"
              v-model="form[item.csdm]"
              style="width: 150px"
            >
            <el-option 
            v-for="a in item.urldz.split(',')"
            :key="a" 
            :label="a" 
            :value="a"></el-option>
            </el-select>
            <el-input
              v-else
              v-model="form[item.csdm]"
              :disabled="item.abled"
              @input="defaultValue(item.csdm, form[item.csdm], item.ball)"
              style="width: 150px"
            ></el-input>
          </template>
          {{ item.cshz }}
        </el-form-item>
      </el-form>
      <div class="btnBox">
        <el-button
          v-if="canSet"
          type="primary"
          @click="saveForm('form')"
          :disabled="waitLoading"
          >确定</el-button
        >
        <el-button
          v-else
          type="primary"
          @click="dialogFormVisible = false"
        >关闭</el-button>
      </div>
    </el-dialog>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
<script>
import myClock from "../components/clock/clock";
import ParamSettingMixin from '@/mixins/ParamSettingMixin';

export default {
  name: "cb",
  components: {myClock},
  mixins: [ParamSettingMixin],
  data() {
    return {
      waitLoading: false,
      kbxmlc: "",
      djlcId: "", // 当前节点状态
      sfycs: true,
      tableHead: {},
      tableData: [],
      tbdwmc: "",
      isOk: false, // 是否可以下一步
      csjg: [], // 是否已经设置过参数
      dialogFormVisible: false, //设置参数
      formItem: [],
      form: {},
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      ispublishAll: '',
      objectType: "", //项目大类1、采购项目 2、工程项目
      setCsdm: "",
      setCqs: "",
      setBall: "",
      dialogVisible:false,//设置报价时间弹窗
      timeForm:{
        dcbjsj:"",
        sfzzbj:''
      },
      dcbjzt:true,//多次报价按钮是否可点击
      bjTime:'',
      intervalBj:null,//报价定时器
      dcbjjssj:null,
      tbdwsl:NaN,
      tbdwyxgsl:NaN,
      tbdwwxgsl:NaN,
      dcbjcs:0,//当前第几次报价
      jmSuccessNum:0,//解密成功单位数
      dqbjsfzzbjj:false,//当前是否最终报价
      pbsfyjs:false,//
      evalEnd: false, // 判断评标是否结束
    };
  },
  methods: {
    // ------------2021-10-26新增
    async publish() {
      let para = {};
      para.djlcId = this.djlcId;
      //    para.djlcId = "投标谢大帅";
      try {
        let res = await this.$api.ispublish(para);
        if (res.status == 200) {
          this.ispublishAll = res.data.data.isPublish;
          this.total = res.data.data.total;
          this.tableData = res.data.data.dcbj;
          this.kbxmlc = res.data.data.kbxmlc;
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (err) {
        console.log("投标人", err);
      }
    },
    // ---------------
    changeInp(name) {
      this.form[name] = this.form[name].replace(/[^\d.]/g, ""); //清除非 数字和小数点的字符
      this.form[name] = this.form[name].replace(/\.{2,}/g, "."); //清除第二个小数点
      this.form[name] = this.form[name].replace(/^\./g, ""); //验证第一个字符是数字而不是字符
      this.form[name] = this.form[name]
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      this.form[name] = this.form[name].replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        "$1$2.$3"
      ); //保留两位小数
      this.form[name] =
        this.form[name].indexOf(".") > 0
          ? this.form[name].split(".")[0].substring(0, 5) +
            "." +
            this.form[name].split(".")[1]
          : this.form[name].substring(0, 5); //限制只能输入7位正整数
    },
    getData() {
      let para = {
        tbdwmc: this.tbdwmc,
        djlcId: this.djlcId,
        loginRole:this.loginRole
      };
      this.waitLoading = true;
      this.kbxmlc=null;
      this.dcbjjssj=null
      this.bjTime=null;
      clearTimeout(this.intervalBj);
      this.intervalBj = null;
      this.$api
        .getCbData(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.tableHead = res.data.data.bjxsmc;
            this.kbxmlc = res.data.data.kbxmlc;
            this.total = res.data.data.data.total;
            //this.csjg = res.data.data.csList;
            this.sfycs = res.data.data.sfycs;
            this.newTips = res.data.data.cscqStr; // 张焱新增字段 2021/12/15
            this.dcbjzt=res.data.data.dcbjzt;//多次报价按钮是否可点击
            var dcbjjssj=res.data.data.dcbjjssj;
            this.tbdwsl=res.data.data.tbdwsl
            this.tbdwyxgsl=res.data.data.tbdwyxgsl
            this.tbdwwxgsl=res.data.data.tbdwwxgsl;
            this.jmSuccessNum=res.data.data.jmSuccessNum
            this.dcbjcs=res.data.data.kbxm.dcbjcs;
            this.dqbjsfzzbj=res.data.data.dqbjsfzzbj
            this.pbsfyjs=res.data.data.pbsfyjs
            this.evalEnd = res.data.data.evalEnd
            if(dcbjjssj){
              var nowTime=new Date().getTime();
              if(dcbjjssj-nowTime>= 1000){
                this.dcbjjssj=dcbjjssj-nowTime;
                this.bjTime = this.dcbjjssj;
                this.bjshenyuFun()
              }
            }
            
            if (res.data.data.tbdwMap) {
              var arr = res.data.data.data.tbdwList;
              arr.forEach((item, index) => {
                for (let key in res.data.data.tbdwMap[item.id]) {
                  item[key] = res.data.data.tbdwMap[item.id][key];
                }
              });
              this.tableData = arr;
            } else {
              this.tableData = res.data.data.data.tbdwList;
            }
            this.waitLoading = false;
          } else {
            this.waitLoading = false;
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
        })
        .catch(() => {});
    },
    //开启多轮报价
    openBj(){
      this.timeForm.dcbjsj = 5;
      this.dialogVisible=true
    },
    //确认报价时间
    saveBjTime(formName) {
      this.$refs[formName].validate(v=>{
        if(v){
          let para = {
           ...this.timeForm,
          };
          this.waitLoading = true;
          this.$api
            .kqdcbj(para)
            .then((res) => {
              if (res.data.meta.success) {
                let obj = {
                  lx: "zb",
                  data: {
                    id: "",
                  },
                };
                this.$emit("send", JSON.stringify(obj));
                this.dialogVisible = false;
                this.waitLoading = false;
              } else {
                this.waitLoading = false;
                this.$message({
                  type: "error",
                  message: res.data.meta.message,
                });
              }
            })
          .catch(() => {});
        }else{
          return false;
        }
      })
      
    },
    //结束报价
    stopBj(){
      this.waitLoading = true;
      this.$api
        .gbdcbj()
        .then((res) => {
          if (res.data.meta.success) {
            clearTimeout(this.intervalBj);
            this.intervalBj = null;
            this.getData(1);
            let obj = {
              lx: "zb",
              data: {
                id: "",
              },
            };
            this.$emit("send", JSON.stringify(obj));
            this.waitLoading = false;
          } else {
            this.waitLoading = false;
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
        })
        .catch(() => {});
    },
    //设置参数
    setCs() {
      let para = {};
      this.waitLoading = true;
      this.$api
        .getKbxmCscqnrForm(para)
        .then((res) => {
          this.waitLoading = false;
          if (res.data.meta.success) {
            if (res.data.data.kcList.length) {
              this.formItem = res.data.data.kcList;
              this.formItem.forEach((item) => {
                let reg = /^[a-z][z]$/g;
                let reg2 = /^[a-z]$/g;
                if (reg.test(item.csdm)) {
                  item.abled = true;
                } else {
                  item.abled = false;
                }
                if (reg2.test(item.csdm)) {
                  item.ball = 1; // 是选球
                } else {
                  item.ball = 0; // 不是选球
                }
              });
              if (res.data.data.csMap) {
                this.form = Object.assign({}, res.data.data.csMap);
              }
              this.dialogFormVisible = true;
            } else {
              this.$message({
                type: "warning",
                message: "无需设置参数",
              });
            }
          }
        })
        .catch(() => {});
    },
    defaultValue(csdm, cqs, ball) {
      this.form[csdm] = this.form[csdm]
        .replace(/[^\d\.\-0]/g, "")
        .replace(/^\./g, "");
      this.setCsdm = csdm;
      this.setCqs = cqs;
      this.setBall = ball;
      // this.validateFrom[csdm] == "";
    },
    changeBallNum(csdm, cqs, ball) {
      // this.waitLoading = true;
      if (ball != 1) return;
      let para = {
        csdm,
        cqs,
      };
      return this.$api
        .hqcqz(para)
        .then((res) => {
          // this.waitLoading = false;
          if (res.data.data == 999) {
            this.form[csdm] = "";
            return 1;
          }
          this.form[csdm + "z"] = res.data.data;
          return 0;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async validateFieldMethods(rule, value, callback) {
      if (!value) {
        callback(new Error("必填项"));
      } else {
        // if (this.validateFrom[this.setCsdm] == 0) {
        //   callback();
        // } else {
        let text = await this.changeBallNum(
          this.setCsdm,
          this.setCqs,
          this.setBall
        );
        if (text == 1) {
          callback(new Error("请输入正确的球号！"));
        } else {
          // this.validateFrom[this.setCsdm] = text;
          callback();
          // }
        }
      }
    },
    //保存参数设置
    saveForm(formName) {
      this.$refs[formName].validate((valide) => {
        if (valide) {
          this.waitLoading = true;
          this.dialogFormVisible = false;
          let para = this.form;
          this.$api
            .saveSzcs(para)
            .then((res) => {
              if (res.data.meta.success) {
                if (this.objectType == "2") {
                  this.getData();
                }
                let obj = {
                  lx: "zb",
                  data: {
                    id: "",
                  },
                };
                this.$emit("send", JSON.stringify(obj));
                this.getData()
              } else {
                this.$message({
                  type: "error",
                  message: res.data.meta.message,
                });
              }
              this.waitLoading = false;
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    //查看投标单位多清单
    lookXq(row) {},
    nextBtn() {
      this.waitLoading = true;
      this.$api
        .checkCqz()
        .then((res) => {
          if (res.data.meta.success) {
            let para = {
              flag: this.kbxmlc.ycdz,
            };
            this.waitLoading = true;
            this.$emit("nextBtn", para);
          } else {
            this.waitLoading = false;
            this.$message({
              type: "warning",
              message: res.data.meta.message,
            });
          }
        })
        .catch((err) => {
          this.waitLoading = false;
          this.$message({
            type: "warning",
            message: err.data.meta.message,
          })
        })
    },
    async initData() {
      let type = await this.getFileType();
      this.objectType = type;
      //项目大类1、采购项目 2、工程项目
      if (type == "1") {
        // 还得区分是否是多次报价的项目
        this.publish();
      } else {
        console.log("type", type);
      }
      this.getData();
    },
    getFileType() {
      return this.$api
        .judgeType()
        .then((res) => {
          return res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //计算剩余时间倒计时
    bjshenyuFun() {
      var _this = this;
      _this.intervalBj = setTimeout(function () {
        if(!_this.bjTime){
          clearTimeout(_this.intervalBj);
          _this.intervalBj = null;
          return
        }
        _this.bjTime = _this.bjTime - 1000;
        
        if (_this.bjTime < 1000) {
          clearTimeout(_this.intervalBj);
          _this.intervalBj = null;
          _this.getData(1);
          return false;
        } else {
          _this.bjshenyuFun();
        }
      }, 1000);
    },
    createMoreReportForm(){
      this.waitLoading = true;
      this.$api.createMoreReportForm().then((res)=>{
        if (res.data.meta.success) {
          this.waitLoading = false;
          this.$message({
            type: "success",
            message: res.data.data,
          });
        }else{
          this.waitLoading = false;
          this.$message({
            type: "error",
            message: res.data.meta.message,
          });
        }
      }).catch((err)=>{})
    }
  },

  created() {
    this.djlcId = this.$route.query.djlcId;
    this.initData();
  },
  destroyed(){
    clearTimeout(this.intervalBj);
    this.intervalBj = null;
  }
};
</script>
<style lang="less" scoped>
.cb {
  .cont-title {
    span {
      font-size: 14px;
      font-weight: normal;
      margin-left: 5px;
    }
  }
  .bjBtn{
    border: 1px solid rgba(0, 96, 178, 0.1);
    border-top: 2px solid #0060b2;
    text-align: center;
    height: calc(100% - 60px);
    padding-top: 80px;
    position: relative;
    p.time{
      font-size: 20px;
      color: #2D2D2D;
      float: left;
      line-height: 320px;
      margin-right:50px;
    }
    >p.total{
      font-size: 16px;
      color: #333333;
    }
    .clear{
      height: 320px;
    }
    .clockBox{
      width: 1050px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .numP{
    font-size: 28px;
    color:#333;
    text-align: center;
    font-weight: bold;
  }
  .bjNumP{
    color:#333;
    font-weight: bold;
    font-size: 18px;
    margin-bottom:10px;
  }
  .bjNum{
    color:#0060B2;
  }
  .dialogBox .el-form{
    background: #f5f5f5;
    padding:10px 0;
  }
}
</style>